<div class="mat-card block-info customer-details">
    <ng-container *ngIf="!customerInfoWidget; else widget">
        <div class="mat-card-title">
            <button *ngIf="!summaryTabSelected" mat-button class="edit-block-button" type="button" color="primary" (click)="edit(customer)">
                {{ customer && customer.id ? "Edit" : "Add" }}
            </button>
            <h2>{{ titleDescriptor }}</h2>
        </div>
        <dl *ngIf="customer && customer.id; else noCustomer">
            <dt>First Name</dt>
            <dd>{{ customer.firstName || "&nbsp;" }}</dd>
            <dt>Last Name</dt>
            <dd>{{ customer.lastName || "&nbsp;" }}</dd>
            <dt>Email</dt>
            <dd>{{ customer.email || "&nbsp;" }}</dd>
            <ng-container *ngIf="customer.phone"
                ><dt>{{ customer.phoneType || "" }} Phone</dt>
                <dd>{{ customer.phone | formatPhone: "x (xxx) xxx-xxxx" || "&nbsp;" }}</dd></ng-container
            >
            <ng-container *ngIf="customer.phone2"
                ><dt>{{ customer.phone2Type || "" }} Phone</dt>
                <dd>{{ customer.phone2 | formatPhone: "x (xxx) xxx-xxxx" || "&nbsp;" }}</dd></ng-container
            >
            <ng-container *ngIf="customer.phone3"
                ><dt>{{ customer.phone3Type || "" }} Phone</dt>
                <dd>{{ customer.phone3 | formatPhone: "x (xxx) xxx-xxxx" || "&nbsp;" }}</dd></ng-container
            >
        </dl>
        <ng-template #noCustomer
            ><p>No {{ titleDescriptor }}</p></ng-template
        >
    </ng-container>
</div>
<ng-template #widget>
    <dl class="redesign-dl" *ngIf="customer && customer.id; else noCustomer">
        <div class="row">
            <dt class="term">First Name</dt>
            <dd class="description">{{ customer.firstName || "&nbsp;" }}</dd>
        </div>
        <div class="row">
            <dt class="term">Last Name</dt>
            <dd class="description">{{ customer.lastName || "&nbsp;" }}</dd>
        </div>
        <div class="row">
            <dt class="term">Email</dt>
            <dd class="description">{{ customer.email || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="customer.phone" class="row">
            <dt class="term">{{ customer.phoneType || "" }} Phone</dt>
            <dd class="description">{{ customer.phone | formatPhone: "x (xxx) xxx-xxxx" || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="customer.phone2" class="row">
            <dt class="term">{{ customer.phone2Type || "" }} Phone</dt>
            <dd class="description">{{ customer.phone2 | formatPhone: "x (xxx) xxx-xxxx" || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="customer.phone3" class="row">
            <dt class="term">{{ customer.phone3Type || "" }} Phone</dt>
            <dd class="description">{{ customer.phone3 | formatPhone: "x (xxx) xxx-xxxx" || "&nbsp;" }}</dd>
        </div>
    </dl>
    <ng-template #noCustomer
        ><p class="no-customer">No {{ titleDescriptor }}</p></ng-template
    >
</ng-template>
